import React from 'react'
import Carditem from './Carditem';
import './Cards.css'

function Cards() {
  return (
    <div className='cards'>
        {/* <h1>Specialised these</h1> */}
        <div className='cards__container'>
            <div className='cards__wrapper'>
                <ul className='cards__items'>
                    <Carditem 
                    src="images/python-logo.png"
                    text="Python"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/openai1.jpg"
                    text="OpenAI"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/a.png"
                    text="Azure"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/aws1.jpg"
                    text="AWS"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/mysql.jpg"
                    text="mysql"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/qw.jpg"
                    text="Tableau"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/react.png"
                    text="React"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/pytorch.png"
                    text="PyTorch"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/fastapi1.jpg"
                    text="FastAPI"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/bedrock2.png"
                    text="Bedrock"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/sql3.png"
                    text="Sql Server"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/mongod.jpg"
                    text="MongoDB"
                    // label="Programming"
                    path='/technology'
                    />
                    <Carditem 
                    src="images/faceh.jpg"
                    text="H/Face"
                    // label="Programming"
                    path='/technology'
                    />
                    {/* <Carditem 
                    src="images/mysql.jpg"
                    text="Mysql"
                    label="Programming"
                    path='/technology'
                    /> */}
                </ul>
            </div>
        </div>
      
    </div>
  )
}

export default Cards
